const transformConsentSource = ({ results } = {}) => {
  const { content = [{}], id } = results?.[0] || {};
  return { ...content?.[0], id };
};

export default transformConsentSource;
